import styled from 'styled-components';

export const DivContainer = styled.div`
  padding: 3em 1em 2em 1em;
  @media only screen and (min-width: 768px) {
    padding: 0em 1em 1em 1em;
  }
`;
export const HeaderForm = styled.div`
  display:flex;
  flex: 1;
  flex-wrap: wrap;
  padding: 0.5em 0;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width:100%;
`;

export const HeaderDateTime = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex-wrap: wrap;

`;
export const DivStatus = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: flex-end;
`;

export const HeaderTitle = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
`;

export const DivCustomerInfo = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: space-between;
`;
export const DivCustomerInfoBox = styled.div`
  padding:10px;
  flex:1;
`;
export const DivCustomerInfoBox1 = styled.div`
  padding: 10px;
  flex: 1 1 100%;
  @media only screen and (min-width: 768px) {
    flex: 1 1 0%;
  }
`;


/*contentTotal: {
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  padding: '1em 0',
  flexWrap: 'wrap'
},
contentFieldTotal: {
  padding: 10,
  flex: 1,
},
contentSubTotal: {
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: '10px 0',
  flexWrap: 'wrap'
},**/

export const DivTotal = HeaderForm.extend`
  display: flex;
  flex:1;

`;
export const DivOrderTotal = HeaderDateTime.extend`
  display: :flex;
  flex-direction: column;
  flex:1;
  width:100%;
`;
export const DivFieldTotal = styled.div`
  flex:1;
  padding: 10px;
`;

export const DivSubTotal = styled.div`
  display:flex;
  flex:1;
  padding:8px;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const DivActions = styled.div`
  display:flex;
  justify-content: flex-end;
  flex:1;
`;



// WEBPACK FOOTER //
// ./src/orders/styled.js